/**
 * Cleans Google tracking parameters from URLs with hash routing.
 * Handles URLs like: https://domain.com/?_gl=...#/review/...
 * Converts them to: https://domain.com/#/review/...
 */
export const cleanGoogleTrackingParams = (): boolean => {
  const currentUrl = window.location.href
  const url = new URL(currentUrl)

  // Check if there are query parameters before the hash
  if (url.search && url.hash) {
    // Remove all query parameters
    url.search = ''

    // Replace the current URL without causing a page reload
    window.history.replaceState(null, '', url.toString())

    return true // URL was cleaned
  }

  return false // No cleaning needed
}
